import { useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import Swal from 'sweetalert2';

const events = [
    'load',
    'mousemove',
    'mousedown',
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mouseup',
    'contextmenu',
    'wheel',
    'keydown',
    'keyup',
    'keypress',
    'input',
    'change',
    'submit',
    'focus',
    'blur',
    'copy',
    'cut',
    'paste',
    'dragstart',
    'dragend',
    'dragenter',
    'dragleave',
    'dragover',
    'drop',
    'scroll'
];

const AppLogout = ({ children }) => {

    const dispatch = useDispatch();
    const timerRef = useRef(null);

    const resetTimer = useCallback(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    useEffect(() => {
        const handleLogoutTimer = () => {
            timerRef.current = setTimeout(() => {
                resetTimer();
                Object.values(events).forEach((item) => {
                    window.removeEventListener(item, resetTimer);
                });
                handleLogoutMethod();
            }, 1200000);
        };

        const handleEvent = () => {
            resetTimer();
            handleLogoutTimer();
        };

        Object.values(events).forEach((item) => {
            window.addEventListener(item, handleEvent);
        });

        return () => {
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, handleEvent);
            });
            resetTimer();
        };
    }, [resetTimer]);

    const handleLogoutMethod = () => {
        sessionStorage.clear();
        localStorage.clear();
        dispatch(logout());
        Swal.fire({
            title: 'Your session has expired. Please login!',
            icon: 'info',
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonColor: '#1B2354',
            confirmButtonText: 'Ok',
            timer: 60000,
            timerProgressBar: true,
            customClass: {
                popup: 'Toastify__toast alrt-time',
                title: 'Toastify__toast-body',
                confirmButton: '...',
                timerProgressBar: 'red'
            },
            willClose: () => {
                window.location.reload();
            }
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            }
        });
    };

    return children;
};

export default AppLogout;